export default "__VITE_ASSET__DetRYIb3__"